/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Start-Boost-232865 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductItem component',
            apply: () => ({
                afterRender(element) {
                    try {
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');

                        if (productItem) {
                            if (productData.product_type == 'Custom Dining Table' 
                                  || (!productData.available && Number(productData.price_min) == 0)
                                  || (productData.variants.length == 1 && Number(productData.price_min) == 0)
                                  || productData.tags.includes('fourhands_quote')) {
                                const otpBtns = productItem.querySelectorAll('.boost-sd__button');
                                if (otpBtns) {
                                    Array.from(otpBtns).forEach(button => {
                                        button.remove();
                                    });
                                }

                                const soldoutLabel = productItem.querySelector('.boost-sd__product-label--soldout');
                                if (soldoutLabel) {
                                    soldoutLabel.remove();
                                }
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });
    }
]);
/* End-Boost-232865 */